import React, {
  useEffect, useState, Suspense, FC,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { ToastContainer, toast } from 'react-toastify'
import jwtDecode from 'jwt-decode'
import { checkoutPageMessage } from '../../constants/messages'
import OpenSignBoxAction from '../../store/reducers/OpenSignUpBoxReducer/OpenSignBoxAction'
import { API } from '../../api'
import 'react-toastify/dist/ReactToastify.css'
import { toastError, toastSuccess } from '../../utils/toast'
import HeaderUserName from '../../components/HeaderUserName'

const RegistrationSideBar = React.lazy(() => import('../../components/RegistrationSideBar'))
const FallbackUI = React.lazy(() => import('../../components/FallbackUI'))

export interface HeaderProps {
  cartL?: any;
  changeUserState?: (args: any) => void;
  pageFrom?: any;
}

const Header: FC<HeaderProps> = (props) => {
  const history = useHistory()
  const buttonRef = React.useRef(null)
  const [isModalOpen, setisModalOpen] = useState(false)
  // @ts-ignore
  const isOpen = useSelector((state) => state.isOpen)
  const dispatch = useDispatch()

  if (isOpen && isModalOpen === false) {
    try {
      setisModalOpen(true)
      const domElement = document.getElementsByClassName('collapse')[0]
      domElement.classList.add('in')
      const link = document.getElementById('navbarDropdownMenuLink-55')

      if (link) {
        link.click()
      }
    } catch (e: any) {
      console.log(e)
    }
  }

  /** ****   Local Scope (State)  Area ************* */
  const [user, setUser] = useState<string | null>(null)
  const [userCopy, setUserCopy] = useState<string | null>(null)
  const [isLogged, setLoggin] = useState(false)
  const [email, setEmail] = useState('')
  const [Loading, setLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [isLoginCard, setCardType] = useState(true)
  const [cartLength, setCartLength] = useState(0)
  const [errorList, setErrorList] = useState<string[]>([])
  /** ************* END ********************************* */

  useEffect(() => {
    if (window.localStorage.getItem('cart') !== null) {
      try {
        const cartItems = JSON.parse(window.localStorage.getItem('cart') || '')

        setCartLength(cartItems.reduce((acc: any, ca: any) => acc + ca.productQty, 0))
      } catch (e) {
        console.log('error', e)
      }
    }

    const jwtToken = window.localStorage.getItem('jwt')

    if (jwtToken !== null) {
      try {
        const data = jwtDecode(jwtToken)
        setUser(data.email)
        setLoggin(true)
      } catch (error) {
        // window.localStorage.removeItem('jwt')
        // history.push('/')
      }
    } else {
      setLoggin(false)
    }
  }, [])

  const logOut = (e: any) => {
    e.preventDefault()
    try {
      window.sessionStorage.clear()
      window.localStorage.clear()
      window.location.href = '/'

      // if(typeof props.history !== 'undefined' ) {
      //     props.history.push('/')
      // }
      // window.location.reload('/');
    } catch (e) {
      console.log('some error', e)
    }
  }

  /**
   *  Method htmlFor clearing error boarder if field is clicked
   * @param {} e
   */
  const removeErroClass = (e: any) => {
    try {
      const Targetclass = e.target.className
      const target = document.getElementById(e.target.id)

      if (Targetclass.includes('ErrorForm') && target) {
        target.classList.remove('ErrorForm')
      }
    } catch (e) {
      console.log('error')
    }
  }

  const handleFormSubmission = (event: any) => {
    event.preventDefault()
    const formData = new FormData()
    let error = false
    const emailRegx = /[\w-]+@([\w-]+\.)+[\w-]+/g
    formData.append('password', `${password}`)
    formData.append('email', `${email}`)
    let tempErrorList = []
    if (email === '') {
      const inputEmail = document.getElementById('inputemail2')
      if (inputEmail) {
        inputEmail.classList.add('ErrorForm')
      }

      tempErrorList.push('emptyEmail')
      // emailError
      error = true
    }
    if (email !== '' && emailRegx.test(email) === false) {
      tempErrorList.push('invalidEmail')
      if (tempErrorList.indexOf('emptyEmail') >= 0) {
        const i = tempErrorList.indexOf('emptyEmail')

        tempErrorList = [
          ...tempErrorList.slice(0, i),
          ...tempErrorList.slice(i + 1, tempErrorList.length),
        ]
      }
      error = true
    }

    if (password.length === 0) {
      const pass1 = document.getElementById('pass12')

      if (pass1) {
        pass1.classList.add('ErrorForm')
      }

      tempErrorList.push('weakpass')
      error = true
    }

    if (error) {
      setErrorList(tempErrorList)
      return 0
    }
    async function login() {
      setLoading(true)
      API.siteApi
        .login(formData)
        .then((response: any) => {
          setLoading(false)

          if (response.success === true) {
            toastSuccess('Succesvol ingelogd !', {
              autoClose: 5000,
            })

            window.localStorage.setItem('jwt', response.data.token)
            window.localStorage.setItem('user', JSON.stringify(response.data))

            const jwtToken = window.localStorage.getItem('jwt')

            if (jwtToken !== null) {
              const data = jwtDecode(jwtToken)
              setUser(data.email)
            }
            if (typeof props.changeUserState === 'function') {
              props.changeUserState(response.data)
            }
            OpenSignBoxAction(false)(dispatch)
            setisModalOpen(false)
            try {
              const domElement = document.getElementsByClassName('collapse')[0]
              domElement.classList.remove('in')

              // @ts-ignore
              buttonRef.current.click()
            } catch (e) {
              console.log('ee', e)
            }
            setLoggin(true)
          } else {
            setLoggin(false)
            toastError('Email or password is incorrect!', {
              autoClose: 5000,
            })
          }
          if (window.location.href.includes('forgot_password')) {
            history.push('/')
          }
        })
        .catch((error) => {
          setLoading(false)
          toastError('Some server error !', {
            position: 'top-left',
            autoClose: 5000,
          })
          console.log('error', error)
        })
    }
    login()
  }
  const onEnterKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.which === 13) {
      handleFormSubmission(e)
    }
  }

  /**
   * Funtion for redirect user to reset passwod page
   *
   */


  const toHome = (e: React.MouseEvent<HTMLAnchorElement>) => {
    try {
      e.preventDefault()
      history.push('/')
    } catch (e) { console.log(e) }
  }

  const tocheckOut = (e: React.MouseEvent<HTMLAnchorElement>) => {
    try {
      e.preventDefault()
      // if (props.pageFrom !== undefined && props.pageFrom === 'profile') {
      //   return 0
      // }
      const numberOfItems = props.cartL !== undefined ? props.cartL : cartLength

      if (numberOfItems === 0) {
        history.push('/')
        return
      }

      // if (localStorage.getItem('tableid') !== null) {
      //   localStorage.removeItem('tableid');
      //   localStorage.setItem('tableid', 'undefined');
      // } else {
      //   localStorage.setItem('tableid', 'undefined');
      // }

      if (localStorage.getItem('restaurant_data') !== null) {
        const rest = JSON.parse(localStorage.getItem('restaurant_data') || '')
        const path = rest.RestaurantName.split(' ').join().toLowerCase().replace(/,/g, '')
        history.push('/checkout')
      } else {
        history.push('/')
      }
    } catch (e) {
      console.log('test', e)
    }
  }
  const toCustomerHome = (e: any) => {
    try {
      e.preventDefault()
      history.push('/home')
    } catch (e) {
      console.log('error', e)
    }
  }
  const handleClose = () => {
    try {
      setEmail('')
      setPassword('')
      setCardType(true)
      setisModalOpen(false)
      OpenSignBoxAction(false)(dispatch)
      const domElement = document.getElementsByClassName('collapse')[0]
      domElement.classList.remove('in')
      // @ts-ignore
      buttonRef.current.click()
      setErrorList([])
      // @ts-ignore
      document.getElementById('inputemail2').classList.remove('ErrorForm')
      // @ts-ignore
      document.getElementById('pass12').classList.remove('ErrorForm')
    } catch (e) {
      //
    }
  }

  const redirectToForgotPassword = (e: any) => {
    e.preventDefault()
    handleClose()
    history.push('/forgot_password')
  }

  return (
    <header id="header" className="header-scroll top-header headrom">
      <nav className="navbar navbar-dark">
        <div className="container">
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={true}
            rtl={false}
            pauseOnFocusLoss={true}
            draggable={true}
            pauseOnHover={true}
          />

          <button
            className="navbar-toggler hidden-lg-up"
            type="button"
            data-toggle="collapse"
            data-target="#mainNavbarCollapse"
          >
            &#9776;
          </button>
          <a className="navbar-brand" href="#!" onClick={toHome}>
            {' '}
            <img className="img-rounded" src="images/logo.png" width="50" height="40" alt="" />{' '}
          </a>
          <div className="collapse navbar-toggleable-md  float-lg-right" id="mainNavbarCollapse">
            <ul className="nav navbar-nav">
              <li className="nav-item">
                {/*{window.location.href.includes('/home') ? null : (*/}
                  <a href="#!" className="nav-link cart-icon" onClick={tocheckOut}>
                    <span className="nav-cart-icon">
                      <sup className="notify-counter">
                        {props.cartL !== undefined ? props.cartL : cartLength}
                      </sup>
                      <svg
                        height="512pt"
                        viewBox="0 -31 512.00026 512"
                        width="512pt"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="m164.960938 300.003906h.023437c.019531 0 .039063-.003906.058594-.003906h271.957031c6.695312 0 12.582031-4.441406 14.421875-10.878906l60-210c1.292969-4.527344.386719-9.394532-2.445313-13.152344-2.835937-3.757812-7.269531-5.96875-11.976562-5.96875h-366.632812l-10.722657-48.253906c-1.527343-6.863282-7.613281-11.746094-14.644531-11.746094h-90c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h77.96875c1.898438 8.550781 51.3125 230.917969 54.15625 243.710938-15.941406 6.929687-27.125 22.824218-27.125 41.289062 0 24.8125 20.1875 45 45 45h272c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15h-272c-8.269531 0-15-6.730469-15-15 0-8.257812 6.707031-14.976562 14.960938-14.996094zm312.152343-210.003906-51.429687 180h-248.652344l-40-180zm0 0" />
                        <path d="m150 405c0 24.8125 20.1875 45 45 45s45-20.1875 45-45-20.1875-45-45-45-45 20.1875-45 45zm45-15c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0" />
                        <path d="m362 405c0 24.8125 20.1875 45 45 45s45-20.1875 45-45-20.1875-45-45-45-45 20.1875-45 45zm45-15c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0" />
                      </svg>
                    </span>
                  </a>
                {/*)}*/}
              </li>
              {isLogged === true ? (
                <HeaderUserName user={user} toCustomerHome={toCustomerHome} logOut={logOut} />
              ) : (
                <li className="nav-item avatar dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    id="navbarDropdownMenuLink-55"
                    data-toggle="modal"
                    data-target="#myModal2"
                    data-backdrop="static"
                    data-keyboard="false"
                  >
                    <img
                      src="images/man.png"
                      width="32"
                      height="32"
                      className="leftspace"
                      alt="avatar"
                    />{' '}
                    Log in
                  </a>

                  <div
                    className="modal right fade"
                    id="myModal2"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="myModalLabel2"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <button
                            type="button"
                            onClick={handleClose}
                            className="close"
                            ref={buttonRef}
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <h4 className="modal-title" id="myModalLabel2">
                            Log in of maak een account aan
                          </h4>
                        </div>
                        <div className="modal-body">
                          {Loading ? <FallbackUI /> : null}

                          <div className="row">
                            {/* REGISTER */}

                            <div className="col-md-12">
                              <div className="widget">
                                <div className="widget-body">
                                  {isLoginCard === true ? (
                                    <form onSubmit={() => false}>
                                      <div className="row">
                                        <div className="form-group col-sm-12">
                                          <label htmlFor="exampleInputEmail1">E-mail</label>
                                          <input
                                            autoComplete="username"
                                            type="email"
                                            className="form-control"
                                            id="inputemail2"
                                            aria-describedby="emailHelp"
                                            placeholder={email}
                                            value={email}
                                            onChange={(e) => {
                                              setEmail(e.target.value)
                                            }}
                                            onClick={(e) => {
                                              removeErroClass(e)
                                            }}
                                            onKeyPress={(e) => onEnterKey(e)}
                                          />
                                          {errorList.indexOf('emptyEmail') >= 0 ? (
                                            <small
                                              style={{
                                                color: 'red',
                                              }}
                                            >
                                              {checkoutPageMessage.get('emptyEmail')}
                                            </small>
                                          ) : null}
                                          {errorList.indexOf('invalidEmail') >= 0 ? (
                                            <small
                                              style={{
                                                color: 'red',
                                              }}
                                            >
                                              {checkoutPageMessage.get('invalidEmail')}
                                            </small>
                                          ) : null}
                                        </div>
                                        <div className="form-group col-sm-12">
                                          <label htmlFor="exampleInputPassword1">Wachtwoord</label>
                                          <input
                                            type="password"
                                            className="form-control pass1"
                                            id="pass12"
                                            placeholder="Wachtwoord"
                                            value={password}
                                            autoComplete="current-password"
                                            onChange={(e) => {
                                              setPassword(e.target.value)
                                            }}
                                            onClick={(e) => {
                                              removeErroClass(e)
                                            }}
                                            onKeyPress={(e) => onEnterKey(e)}
                                          />
                                          {errorList.indexOf('weakpass') >= 0 ? (
                                            <small
                                              style={{
                                                color: 'red',
                                              }}
                                            >
                                              {checkoutPageMessage.get('passlogin')}
                                            </small>
                                          ) : null}
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-sm-4">
                                          <p>
                                            {' '}
                                            <a
                                              href=""
                                              className="btn theme-btn "
                                              onClick={(e) => handleFormSubmission(e)}
                                            >
                                              Log in
                                            </a>
                                          </p>
                                        </div>
                                      </div>
                                      <div className="loginf">
                                        <p>
                                          Geen account?
                                          <a
                                            href="#"
                                            className="registerlink"
                                            onClick={(e) => { e.preventDefault(); setCardType(false) }}
                                          >
                                            Maak nu een account aan.
                                          </a>
                                          Wachtwoord vergeten?
                                          <a
                                            href="#"
                                            className="registerlink"
                                            onClick={redirectToForgotPassword}
                                          >
                                            Klik hier
                                          </a>
                                        </p>
                                      </div>
                                    </form>
                                  ) : (
                                    <Suspense fallback={<FallbackUI />}>
                                      <RegistrationSideBar
                                        refbtn={buttonRef}
                                        changeToLogin={setCardType}
                                      />
                                    </Suspense>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}
export default Header
